import React from 'react'

import Base from '../_Base'

const Unavailable = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      d="M22.2,18.4 L16.7,14.5 L19.3,12.7 C19.8,12.4 19.9,11.8 19.6,11.3 C19.5,11.2 19.4,11.1 19.3,11 L9.3,4.1 C9,3.9 8.6,3.9 8.3,4.1 C7.9,4.2 7.7,4.6 7.7,5 L7.7,8.3 L3,5 L1.8,6.6 L7.7,10.7 L7.7,18.8 C7.7,19.2 7.9,19.5 8.2,19.7 C8.3,19.8 8.5,19.8 8.7,19.8 C8.9,19.8 9.1,19.7 9.3,19.6 L14.9,15.7 L21,20 L22.2,18.4 Z M9.7,6.9 L16.9,11.9 L14.9,13.3 L9.7,9.7 L9.7,6.9 Z M9.7,16.9 L9.7,12.1 L13.2,14.5 L9.7,16.9 Z"
      fillRule="evenodd"
    />
  </Base>
)

export default Unavailable
